import React from 'react'
import Layout from '../Layout'
import First_pane from './First_pane'

const Biote_lapis = () => {
  return (
    <Layout>
    <First_pane />

    </Layout>
  )
}

export default Biote_lapis